// Booking rules (ADR 0009), mirrored from the server, which re-checks every
// booking (AiVoiceInterview::Book). The calling window matches
// AiVoiceInterview::CallingWindow: weekdays, 9:30am to 7pm in the candidate's
// time, both ends inclusive, so 7:00pm is a bookable start.
export const BOOKING_RULES = {
  windowStartMinutes: 9 * 60 + 30,
  windowEndMinutes: 19 * 60,
  stepMinutes: 15,
  leadMinutes: 60,
  defaultRangeDays: 7,
  linkExpiryDays: 7,
  callMinutes: 10
} as const;
